function initial(arr) {
    return arr.slice(0, -1);
}

export { initial };
